import { FieldComponent } from "./chunk-THKH3LMW.js";
import { CheckableGroup_MoreButton_default } from "./chunk-PIOYGWYS.js";
import { CheckableGroupContext } from "./chunk-YG26ROD3.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/CheckableGroup/CheckableGroup.tsx
import React, { useMemo, useState } from "react";
import clsx from "clsx";
var CHECKABLE_GROUP_CLASSNAME_MAP = {
  direction: {
    vertical: "",
    horizontal: "pd-checkable-group--horizontal"
  }
};
var CheckableGroup = _a => {
  var _b = _a,
    {
      children,
      variant = "primary",
      direction = "vertical",
      name,
      label,
      disabled,
      className,
      maxItems = Infinity,
      moreButton = /* @__PURE__ */React.createElement(CheckableGroup_MoreButton_default, null)
    } = _b,
    rest = __objRest(_b, ["children", "variant", "direction", "name", "label", "disabled", "className", "maxItems", "moreButton"]);
  const [totalItems, setTotalItems] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);
  const context = useMemo(() => ({
    name,
    variant,
    disabled,
    maxItems,
    moreButton,
    totalItems,
    setTotalItems,
    isExpanded,
    setIsExpanded
  }), [name, variant, disabled, maxItems, moreButton, totalItems, setTotalItems, isExpanded, setIsExpanded]);
  return /* @__PURE__ */React.createElement(CheckableGroupContext.Provider, {
    value: context
  }, /* @__PURE__ */React.createElement(FieldComponent, __spreadValues({
    as: "fieldset",
    name: "group-".concat(name),
    label,
    disabled,
    className: clsx("pd-checkbable-group", CHECKABLE_GROUP_CLASSNAME_MAP.direction[direction], className)
  }, rest), /* @__PURE__ */React.createElement("legend", {
    className: "pd-checkable-group__legend"
  }, /* @__PURE__ */React.createElement(FieldComponent.Label, {
    as: "span"
  })), children, /* @__PURE__ */React.createElement(FieldComponent.ValidationMessage, null), /* @__PURE__ */React.createElement(FieldComponent.Description, null)));
};
var CheckableGroup_default = CheckableGroup;
export { CheckableGroup_default };